module.exports = __webpack_public_path__ + "static/media/heart33.8cb83333.svg";